<template>
    <p-dms-treeview-entry
        :entry = "folder"
    >
        <template v-slot:icon>
            <v-icon
                size  = "21"
                color = "primary"
            >
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
            </v-icon>
        </template>
    </p-dms-treeview-entry>
</template>

<script>

import PDmsTreeviewEntry from "@/modules/dms/treeview/components/private/PDmsTreeviewEntry.vue";

export default {
    name: "PDmsTreeviewFolder",
    components: {
        PDmsTreeviewEntry
    },

    props: {
        folder: {

        },

        open: {

        }
    },
}
</script>

<style scoped>

</style>